/**
 * Bascule CFA / OF, reprise du helper `modeSwitch` de la maquette.
 * Le mode conditionne le parcours : CERFA et contrat en CFA, session de
 * formation et certificat en OF (CDC §2.2).
 */
export function BasculeMode({
  mode,
  onChanger,
  desactive,
}: {
  mode: 'CFA' | 'OF';
  onChanger: (mode: 'CFA' | 'OF') => void;
  desactive?: boolean;
}): JSX.Element {
  return (
    <div role="group" aria-label="Mode du dossier" className="flex items-center gap-1 rounded-xl border border-gray-200 bg-white p-1">
      {(['CFA', 'OF'] as const).map((valeur) => {
        const actif = mode === valeur;
        return (
          <button
            key={valeur}
            type="button"
            disabled={desactive}
            onClick={() => onChanger(valeur)}
            aria-pressed={actif}
            className={`rounded-lg px-3.5 py-1.5 text-xs font-bold transition disabled:cursor-not-allowed ${
              actif
                ? valeur === 'CFA'
                  ? 'bg-codialis-navy text-white'
                  : 'gradient-mint text-codialis-navy'
                : 'text-codialis-gray hover:bg-gray-50'
            }`}
          >
            Mode {valeur}
          </button>
        );
      })}
    </div>
  );
}

/**
 * Mode du dossier en lecture seule.
 *
 * Le mode d'un dossier est arrêté à l'inscription et découle du parcours de
 * l'apprenant — contrat d'apprentissage en CFA, session de formation en OF. Le
 * dossier l'affiche donc, il ne le fait pas choisir : une bascule à cet endroit
 * laissait croire que le pôle administratif décide du mode dossier par dossier.
 */
export function BadgeMode({ mode }: { mode: 'CFA' | 'OF' }): JSX.Element {
  return (
    <span
      className={`rounded-xl px-3.5 py-1.5 text-xs font-bold ${
        mode === 'CFA'
          ? 'bg-codialis-navy text-white'
          : 'gradient-mint text-codialis-navy'
      }`}
      title={
        mode === 'CFA'
          ? 'Parcours CERFA / contrat d’apprentissage'
          : 'Session de formation et certificat de réalisation'
      }
    >
      Mode {mode}
    </span>
  );
}
